import { css } from '@emotion/css';
import { theme } from 'antd';
import { useMemo } from 'react';

export const useNewsClassNames = () => {
  const { token } = theme.useToken();

  return useMemo(
    () => ({
      mbLg: css`
        margin-bottom: ${token.paddingLG}px;
      `,
      mbSm: css`
        margin-bottom: ${token.paddingSM}px;
      `,
      mtSm: css`
        margin-top: ${token.paddingSM}px;
      `,
      mb0: css`
        margin-bottom: 0;
      `,
      ptLg: css`
        padding-top: ${token.paddingLG}px;
      `,
      colGapLarge: css`
        column-gap: ${token.paddingLG}px;
      `,
      flexGrow: css`
        flex-grow: 1;
      `,
      statusTag: css`
        margin: 0;
        width: 110px;
        text-align: center;
      `,
      statusFormItem: css`
        .ant-form-item-control {
          display: flex;
          flex-direction: row;
          align-items: center;
          column-gap: ${token.paddingSM}px;
        }
      `,
      attachmentEntry: css`
        border: 1px solid ${token.colorBorder};
        border-radius: ${token.borderRadiusLG}px;
        padding: ${token.paddingSM}px;
      `,
      pdfLink: css`
        word-break: break-all;
        font-weight: 500;
      `,
      nowrap: css`
        white-space: nowrap;
      `,
      uploadButton: css`
        display: block;
        width: 100%;

        .ant-upload-select {
          width: 100%;
        }
      `,
      w100: css`
        width: 100%;
      `,
      newsListDashboard: css`
        max-height: 400px;
        overflow: auto;
        padding-top: ${token.paddingSM}px !important;

        .ant-list {
          max-width: 2000px;
          margin: 0 auto;
        }
      `,
      newsListModal: css`
        padding-top: ${token.paddingSM}px !important;
      `,
      sideContent: css`
        width: 100%;
        position: sticky;
        top: 0;
      `,
    }),
    [token]
  );
};
